module.exports = __webpack_public_path__ + "img/henkel-tesistan.65d2dca7.jpg";